<app-header></app-header>
<app-sidebar-services></app-sidebar-services>
<app-header-menu></app-header-menu>
<div class="container-fluid"
  style="padding-left: 100px; padding-top: 66px; background: var(--snow-light); min-height: 100vh;">
  <router-outlet></router-outlet>
</div>
